export enum AsyncComponentLayoutEnum {
    Logo = 'Logo',
    LogoIcon = 'LogoIcon',
    Customizer = 'Customizer',
    HorizontalHeader = 'HorizontalHeader',
    HorizontalSidebar = 'HorizontalSidebar',
    VerticalHeaderVue = 'VerticalHeaderVue',
    VerticalSidebarVue = 'VerticalSidebarVue',
}

export const layoutComponents = {

    [ AsyncComponentLayoutEnum.Logo ]: () => import( '@/layouts/full/logo/Logo.vue' ),
    [ AsyncComponentLayoutEnum.LogoIcon ]: () => import( '@/layouts/full/logo/LogoIcon.vue' ),
    [ AsyncComponentLayoutEnum.Customizer ]: () => import( '@/layouts/full/customizer/Customizer.vue' ),
    [ AsyncComponentLayoutEnum.HorizontalHeader ]: () => import( '@/layouts/full/horizontal-header/HorizontalHeader.vue' ),
    [ AsyncComponentLayoutEnum.HorizontalSidebar ]: () => import( '@/layouts/full/horizontal-sidebar/HorizontalSidebar.vue' ),
    [ AsyncComponentLayoutEnum.VerticalHeaderVue ]: () => import( '@/layouts/full/vertical-header/VerticalHeader.vue' ),
    [ AsyncComponentLayoutEnum.VerticalSidebarVue ]: () => import( '@/layouts/full/vertical-sidebar/VerticalSidebar.vue' ),


}
